import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINT } from '../../../shared/injection-tokens';
import { LoginInput, AuthResponse, ApiResponseWrapper } from '../../../models/interfaces/auth.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private readonly http: HttpClient,
    @Inject(API_ENDPOINT) private readonly apiEndpoint: string
  ) {}

  login(credentials: LoginInput): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(this.apiEndpoint + 'auth/login', credentials);
  }

  refreshToken(refreshToken: string): Observable<ApiResponseWrapper<{ accessToken: string; refreshToken: string }>> {
    return this.http.post<ApiResponseWrapper<{ accessToken: string; refreshToken: string }>>(
      this.apiEndpoint + 'auth/refresh',
      { refreshToken }
    );
  }

  logout(refreshToken: string): Observable<ApiResponseWrapper<null>> {
    return this.http.post<ApiResponseWrapper<null>>(
      this.apiEndpoint + 'auth/logout',
      { refreshToken }
    );
  }

  forgotPassword(email: string): Observable<ApiResponseWrapper<null>> {
    return this.http.post<ApiResponseWrapper<null>>(
      this.apiEndpoint + 'auth/forgot-password',
      { email }
    );
  }

  resetPassword(token: string, newPassword: string): Observable<ApiResponseWrapper<null>> {
    return this.http.post<ApiResponseWrapper<null>>(
      this.apiEndpoint + 'auth/reset-password',
      { token, newPassword }
    );
  }

  activateAccount(email: string, token: string, newPassword: string): Observable<ApiResponseWrapper<null>> {
    return this.http.post<ApiResponseWrapper<null>>(
      this.apiEndpoint + 'auth/activate-account',
      { email, token, newPassword }
    );
  }

  getProfile(): Observable<ApiResponseWrapper<any>> {
    return this.http.get<ApiResponseWrapper<any>>(this.apiEndpoint + 'auth/profile');
  }

  changePassword(currentPassword: string, newPassword: string): Observable<ApiResponseWrapper<null>> {
    return this.http.post<ApiResponseWrapper<null>>(
      this.apiEndpoint + 'auth/change-password',
      { currentPassword, newPassword }
    );
  }
}
